import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SftpComponent } from './sftp.component';
const routes: Routes = [ { path: '', component: SftpComponent }];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SftpRoutingModule { }
